import { api } from '@/scripts/api';

export const CustomInsertTagsService = {

    getAll(config = {}){
        return new Promise((resolve, reject) => {
            const service = '/service/CustomTags/'
            const endpoint = api.applyODataParams(service, config)

            api.get(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },

    get(id){
        return new Promise((resolve, reject) => {
            const service = `/service/CustomTags/?$filter=Id eq ${id}`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    post(payload){
        return new Promise((resolve, reject) => {
            const service = '/api/CustomTags/'

            api.post(service, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    put(id, payload){
        return new Promise((resolve, reject) => {
            const service = `/api/CustomTags/${id}`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    delete(id){
        return new Promise((resolve, reject) => {
            const service = `/api/CustomTags/${id}`;

            api.delete(service)
                .then(resolve)
                .catch(reject)
        })
    }
}